import * as React from 'react'
import TrialLessonContentPc from '../../public/trial_lesson_content_pc.png'
import TrialLessonContentSp from '../../public/trial_lesson_content_sp.png'
import styles from './index.module.scss'

type Props = { isPc: boolean }

export const TrialLessonContentForAB = ({ isPc }: Props) => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <img
          src={isPc ? TrialLessonContentPc.src : TrialLessonContentSp.src}
          alt="Trial Lesson Content"
          className={styles.image}
        />
      </div>
    </section>
  )
}
